import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsEngageSegmentationAdminPageEnabled = () => boolean;
export const useIsEngageSegmentationAdminPageEnabled: UseIsEngageSegmentationAdminPageEnabled = () => {
  const experimentValue = useExperimentTreatmentWithoutReporting('EngageSegmentationAdminPage') as number;

  return experimentValue > 0;
};
